import { render, staticRenderFns } from "./ExpertCallButton.vue?vue&type=template&id=aa4dc482&"
import script from "./ExpertCallButton.vue?vue&type=script&lang=js&"
export * from "./ExpertCallButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpertCallButton.vue?vue&type=style&index=0&id=aa4dc482&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports